module.exports = __webpack_public_path__ + "newprotal/img/index-pic5.914bafa8.png";